import { render, staticRenderFns } from "./FilterComponentKS.vue?vue&type=template&id=5c4620da"
import script from "./FilterComponentKS.vue?vue&type=script&lang=js"
export * from "./FilterComponentKS.vue?vue&type=script&lang=js"
import style0 from "./FilterComponentKS.vue?vue&type=style&index=0&id=5c4620da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports